<template>
    <div class="h5exhibitionDetails">
        <!-- 加载状态 -->
        <!-- <el-loading v-loading="loading" element-loading-text="正在加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"> -->
            <!-- 错误提示 -->
            <div v-if="errorMsg" class="error-message">
                <el-alert :title="errorMsg" type="error" show-icon :closable="false" />
            </div>
            
            <div class="exhibitionCenterDetails_breadcrumb">
                <el-breadcrumb :separator-icon="ArrowRight">
                    <el-breadcrumb-item>便捷服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/trainServices' }">培训服务</el-breadcrumb-item>
                    <!-- <el-breadcrumb-item :to="{ path: zhType == '1' ? '/exhibitionCenter#exhibitionCenter_tj' : '/exhibitionNotice' }">{{ zhType == '1' ? '推荐展会' : '展会公告' }}</el-breadcrumb-item> -->
                    <el-breadcrumb-item class="zhmc">{{ exhibitionDetailsData.pxmc }}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="exhibitionCenterDetails_content " id="exhibitionCenterDetails_content">
                <div class="exhibitionCenterDetails_content_head">
                    <div class="exhibitionCenterDetails_content_head_left" >
                        <!-- <img v-if="exhibitionDetailsData.urls?.length>0" :src="commenUrl+exhibitionDetailsData.urls[0]" alt="" />
                        <img v-else src="@/assets/images/newsDefault.png" alt="" /> -->
                        <div class="exhibitionCenterDetails_content_head_left_desc">
                     
                                <div class="exhibitionCenterDetails_content_head_left_desc_title">
                                    {{ exhibitionDetailsData.pxmc }}
                                </div>
                         
                                <div class="exhibitionCenterDetails_content_head_left_desc_time_place">
                                <div class="exhibitionCenterDetails_content_head_left_desc_time">
                                  
                                </div>
                                <div class="exhibitionCenterDetails_content_head_left_desc_place">
                                    {{ exhibitionDetailsData.pxkssj ? exhibitionDetailsData.pxkssj.split(' ')[0] : '-' }} - {{ exhibitionDetailsData.pxjssj ? exhibitionDetailsData.pxjssj.split(' ')[0] : '-'  }}  {{ exhibitionDetailsData.pxdd }}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div style="margin-top: .26rem;display: flex; flex-wrap: wrap;align-items: baseline;">
                        <div style="width: 1.50rem;font-size: .24rem;color: #BEBEBE;"> 培训简介：</div> 
                        <div style="flex: 1;font-size: .24rem;color: #5C5C5C;line-height: .44rem;">{{exhibitionDetailsData.pxjj }}</div>      
                    </div>
                     <div v-if="status!=2" :class="['wui-background-color-' + themeColor]" class="btn1" @click="urlTo(exhibitionDetailsData)" >
                                立即报名
                        </div>
                </div>
            </div>
        <div class="exhibitionCenterDetails_content_tab "> 
            <div class="exhibitionCenterDetails_content_tab_item" >
                <span 
                  :class="{'active': item.label === activeTab}" 
                  v-for="item in tabList" 
                  :key="item.label"
                  @click="switchTab(item.label)"
                >{{ item.label }}</span>
            </div>
            <div class="exhibitionCenterDetails_content_tab_box">
                <div class="exhibitionCenterDetails_content_tab_box_line" v-show="activeTab === '培训信息'">
                    <div v-html="exhibitionDetailsData.pxxq || '暂无培训信息'" class="expo-detail-content"></div>
                </div>
                <div class="exhibitionCenterDetails_content_tab_box_line" v-show="activeTab === '培训总结'">
                    <div v-html="exhibitionDetailsData.pxhg || '暂无培训总结'" class="expo-layout-content"></div>
                </div>
            </div>
        </div>
        <!-- </el-loading> -->
    </div>
    
    <!-- 图片查看弹窗 -->
    <!-- <el-dialog 
      v-model="imageDialogVisible"
      :title="imageDialogTitle"
      width="400px"
      height="350px"
      align-center
      :before-close="() => { imageDialogVisible = false }"
    >
      <div style="display: flex; justify-content: center; align-items: center; padding: 20px; min-height: 250px;">
        <img 
          :src="currentImageSrc || '@/assets/images/newsDefault.png'" 
          :alt="currentImageSrc ? imageDialogTitle : '暂无图片'" 
          style="max-width: 100%; max-height: 280px; object-fit: contain; cursor: zoom-out;"
        >
      </div>
    </el-dialog> -->
  </template>
<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ArrowRight } from '@element-plus/icons-vue'

const { proxy } = getCurrentInstance();
const route = useRoute()
const router = useRouter()
// 获取路由信息
const id = ref(route.query.id)
const status= ref(route.query.status)
// tab数据
const tabList = ref([
    {
        label: '培训信息'
    },
    {
        label: '培训总结'
    },
])
 const urlTo = (url) => {
        window.open('https://mall.nfstzx.com/industry/dataAcquisitionForm?id=1194609687106693203');
  }
// 当前选中的tab - 根据来源决定是否使用保存的标签页状态
// 如果是从详情页返回(fromDetails=true)，则使用保存的标签页状态；否则默认显示第一个标签页
const activeTab = ref(tabList.value[0].label)

// 切换tab
let switchTab = (tabLabel) => {
  activeTab.value = tabLabel
}
// 定义展会详情数据变量
const exhibitionDetailsData = ref({})
const loading = ref(false)
const errorMsg = ref('')

//展会详情
const exhibitionDetails = () =>{  
    loading.value = true
    errorMsg.value = ''
    
    proxy.$request({
        url: "XXPX_TRAINDETAIL",
        method: "post",
        data:{
          id: id.value
        }
      }).then((res) => {
        loading.value = false
        if (res.data.code == "000") {
            exhibitionDetailsData.value = res.data.result || {};
            // 延迟处理视频元素和过滤SVG图片，确保DOM已更新
            setTimeout(() => {
              processVideoElements();
              filterSvgImages();
            }, 300);
        } else {
            errorMsg.value = res.data.message || '获取展会详情失败'
        }
      }).catch((err) => {
        loading.value = false
        errorMsg.value = '网络请求失败，请稍后重试'
        console.error('获取展会详情失败:', err);
      });
}
// 过滤特定的SVG图片（带有attr-src指向mp4文件但src为svg的图片）
const filterSvgImages = () => {
  try {
    // 使用requestAnimationFrame确保在浏览器下一次重绘前执行
    requestAnimationFrame(() => {
      // 获取所有需要处理的容器
      const containers = document.querySelectorAll('.exhibition_details_content, .exhibition_summary_content');
      
      containers.forEach(container => {
        if (!container) return;
        
        // 查找符合条件的SVG图片：带有attr-src指向mp4文件且src为特定svg的图片
        const svgImages = container.querySelectorAll('img[attr-src*=".mp4"][src*="acquiesce.e3ed5a35.svg"]');
        
        if (svgImages.length > 0) {
          console.log(`找到需要过滤的SVG图片数量: ${svgImages.length}`);
          svgImages.forEach(img => {
            // 隐藏这些SVG图片
            img.style.display = 'none';
            // 可选：添加数据属性标记已处理
            img.setAttribute('data-svg-filtered', 'true');
          });
        }
      });
    });
  } catch (error) {
    console.error('过滤SVG图片时发生错误:', error);
  }
}

// 处理在线视频链接图片的函数
// 分批处理视频元素的函数
const processVideoElements = () => {
  try {
    // 获取带有attr-src属性且值包含.mp4扩展名的视频链接图片
    const videoImages = document.querySelectorAll('.expo-detail-content img[attr-src*=".mp4"], .expo-layout-content img[attr-src*=".mp4"]');
    
    if (videoImages.length === 0) {
      console.log('没有找到需要处理的在线视频链接图片');
      return;
    }
    
    console.log('找到需要处理的视频图片数量:', videoImages.length);
    
    // 分批处理视频，每批处理的数量
    const batchSize = 5;
    // 转换为数组以便使用slice方法
    const videoImagesArray = Array.from(videoImages);
    
    // 分批处理函数
    const processBatch = (batch) => {
      batch.forEach(img => {
        try {
          // 获取视频链接并清理格式（移除反引号）
          let videoSrc = img.getAttribute('attr-src');
          if (videoSrc) {
            // 移除开头和结尾的反引号以及可能的空格
            videoSrc = videoSrc.replace(/^`\s*|\s*`$/g, '').trim();
            
            // 检查是否已经处理过这个图片
            if (img.hasAttribute('data-video-processed')) {
              return;
            }
            
            // 创建视频容器
            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'online-video-wrapper';
            
            // 创建视频元素
            const video = document.createElement('video');
            video.src = videoSrc;
            video.controls = true; // 添加控制条
            video.preload = 'metadata'; // 预加载视频元数据
            video.className = 'online-video-container';
            
            // 视频加载失败时的处理
            video.onerror = function() {
              console.error('视频加载失败:', videoSrc);
              img.style.display = 'block'; // 加载失败时显示原图片
              if (videoWrapper && videoWrapper.parentNode) {
                videoWrapper.parentNode.removeChild(videoWrapper);
              }
            };
            
            // 在图片前插入视频容器
            videoWrapper.appendChild(video);
            img.parentNode.insertBefore(videoWrapper, img);
            
            // 标记为已处理
            img.setAttribute('data-video-processed', 'true');
            // 隐藏原图片
            img.style.display = 'none';
          }
        } catch (imgError) {
          console.error('处理单个视频图片时出错:', imgError);
          // 出错时显示原图片
          img.style.display = 'block';
        }
      });
    };
    
    // 执行分批处理
    for (let i = 0; i < videoImagesArray.length; i += batchSize) {
      const batch = videoImagesArray.slice(i, i + batchSize);
      // 使用setTimeout创建微任务队列，避免一次性处理过多DOM操作
      setTimeout(() => {
        processBatch(batch);
      }, i / batchSize * 100); // 每批间隔一定时间
    }
  } catch (error) {
    console.error('处理视频元素时出错:', error);
  }
}
onMounted(() => {
    // 如果有ID参数，则获取展会详情
    if (id.value) {
        exhibitionDetails()
    }
})
</script>
<style lang="less" scoped>
.h5exhibitionDetails{
    height: 100%;
    background: #f7f7f7;
    // padding-top: 20px;
    
    .error-message {
        width: 100%;
        // margin: 20px auto;
        padding: 0 20px;
    }
    
    .expo-detail-content,
    .expo-layout-content {
        padding: 20px; // 内容距离两边10%
        min-height: 400px;
        text-align: left; // 文字居左对齐
    }
    
    .expo-detail-content :deep(p),
    .expo-layout-content :deep(p) {
        margin-bottom: 16px;
        line-height: 1.8;
        text-align: left; // 确保段落文字居左
        max-width: 100%; // 确保段落不超出容器
    }
    
    // 图片样式 - 撑满容器
    .expo-detail-content :deep(img),
    .expo-layout-content :deep(img) {
        max-width: 100% !important; // 富文本宽度100%
        width: 100% !important; // 强制撑满容器宽度
        height: auto !important;
        display: block !important;
        cursor: pointer;
        margin: 0 auto !important; // 图片居中显示
        object-fit: contain !important; // 保持图片比例
        box-sizing: border-box !important; // 确保内边距和边框不影响宽度
    }
    
    // 视频样式
    .expo-detail-content :deep(video),
    .expo-layout-content :deep(video) {
        max-width: 100%; // 富文本宽度100%
        height: auto;
        display: block;
        overflow: hidden; // 防止溢出
        margin: 0 auto; // 视频居中显示
    }
    
    // 不对视频链接图片进行特殊处理
    
    // 视频容器样式
    .video-wrapper {
        position: relative;
        width: 100%;
        // max-width: 800px;
        margin: 16px 0;
    }
    
    // 视频播放器样式
    .video-player {
        width: 100%;
        height: auto;
        display: block;
    }
    
    
    
    .exhibitionCenterDetails_breadcrumb{
        // height: 50px;
        background: #FFFFFF;
        padding: .3rem .28rem;
        color: #333333;
      
       
        .el-breadcrumb{
            line-height: 20px;
        }
        
        .zhmc {
            max-width: 40%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .exhibitionCenterDetails_content{
        background: #FFFFFF;
        padding: .28rem;
         border-top:.02rem solid #E6E6E6 ;
        // margin-top: 20px;
        .exhibitionCenterDetails_content_head{
            // height: 174px;
            // display: flex;
            // justify-content: space-between;
            // align-items: center;
            .exhibitionCenterDetails_content_head_left{
                height: 100%;
                display: flex;
                align-items: center;
                flex: 1;
                justify-content: space-between;
                // max-width: calc(100% - 380px);
                img{
                    width: 280px;
                    height: 174px;
                    margin-right: 20px;
                    border-radius: 10px;
                    flex-shrink: 0;
                }
                .exhibitionCenterDetails_content_head_left_desc{
                    height: 100%;
                    width: 100%;
                    // flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    // justify-content: space-between;
                   

                    .exhibitionCenterDetails_content_head_left_desc_title{
                       font-family: PingFangSC, PingFang SC;
                        font-weight: 600;
                        font-size: .36rem;
                        color: #1A1A1A;
                        line-height: .5rem;
                        text-align: right;
                        font-style: normal;
                    }
                    .exhibitionCenterDetails_content_head_left_desc_subtitle{
                    font-family: PingFangSC, PingFang SC;
                    font-size: .24rem;
                    color: #5C5C5C;
                    line-height: .24rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-break: break-word;
                }
                    .exhibitionCenterDetails_content_head_left_desc_time_place{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        font-family: PingFangSC, PingFang SC;
                        font-size: .24rem;
                    color: #5C5C5C;
                    line-height: .24rem;
                        .exhibitionCenterDetails_content_head_left_desc_place{
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                             font-size: .24rem;
                            color: #5C5C5C;
                            line-height: .24rem;
                            margin-top: .12rem
                        }
                    }
                    .exhibitionCenterDetails_content_head_left_desc_btn{
                        display: inline-block;
                        width: 160px;
                        height: 33px;
                        line-height: 33px;
                        text-align: center;
                        background: linear-gradient( 180deg, #FEF3F2 0%, #FCE3E0 100%);
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 12px;
                        color: #F23030;
                        white-space: nowrap;
                        border-radius: 17px;
                        margin: 0;
                        span{
                            font-size: 14px;
                            font-weight: 500;
                            padding: 0 2px;
                            line-height: 18px;
                        }
                    }
                    .exhibitionCenterDetails_content_head_left_desc_btn_status1{
                        background: linear-gradient( 180deg, #E6F7EF 0%, #C3F1DD 100%);
                        color: #36A47F;
                    }
                    .exhibitionCenterDetails_content_head_left_desc_btn_status2{
                        background: linear-gradient( 180deg, #F5F5F5 0%, #EAEAEA 100%);
                        color: #8C8C8C;
                    }
                }
            }
            .exhibitionCenterDetails_content_head_right{
                flex-shrink: 0;
                .exhibitionCenterDetails_content_head_imgbox{
                    width: 360px;
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .exhibitionCenterDetails_content_head_imgbox_img{
                        height: 140px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        img{
                            width: 92px;
                            height: 92px;
                            border-radius: 50%;
                            cursor: pointer;
                        }
                        div{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #595959;
                            line-height: 20px;
                        }
                        .p1{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #717271;
                            line-height: 17px;
                        }
                        .p2{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #595959;
                            line-height: 17px;
                        }
                    }
                    .exhibitionCenterDetails_content_head_imgbox_img:not(:last-child){
                        position: relative;
                    }
                    .exhibitionCenterDetails_content_head_imgbox_img:not(:last-child)::after{
                        content: '';
                        position: absolute;
                        top: 24px;
                        right: -20px;
                        width: 1px;
                        height: 92px;
                        background: #EDEDED;
                    }
                }
            }
        }
    }
    .exhibitionCenterDetails_content_tab{
        padding: 20px;
        background: #FFFFFF;
        border-bottom-right-radius:20px ;
         border-bottom-left-radius:20px ;
        .exhibitionCenterDetails_content_tab_item{
            display: flex;
            align-items: center;
            border-bottom: 1px solid #D8D8D8;
            padding: 10px 0;
            span{
                margin-right: 40px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
               font-size: .28rem;
               color: #1A1A1A;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                padding-bottom: 8px;
                
                // &:hover,
                &.active{
                   font-size: .28rem;
                   color: #1A1A1A;
                    font-weight: 600;
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: 0;
                        top: .6rem;
                        left: 0;
                        width: 100%;
                        height: .04rem;
                        background: #191919;
                    }
                }
            }
        }
        .exhibitionCenterDetails_content_tab_box{
            padding: 30px 0 0;
            background: #fff;    
            .exhibitionCenterDetails_content_tab_box_line{
                // 为分页组件所在的容器添加居中样式
                .el-pagination {
                    display: flex;
                    justify-content: center;
                    margin: 20px 0;
                }
                .list{
                            .list_item{
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                font-family: PingFangSC, PingFang SC;
                                font-size: 16px;
                                color: #191919;
                                line-height: 22px;
                                width: 100%;
                                background: #F5F5F5;
                                border-radius: 10px;
                                padding: 18px 30px;
                                margin-bottom: 20px;
                                cursor: pointer;
                                
                                .list_item_left{
                                    white-space: nowrap;
                                    overflow: hidden;
                                    font-weight: 600;
                                    text-overflow: ellipsis;
                                    flex-grow: 1;
                                    max-width: 100%;
                                }
                                .list_item_right{
                                    font-size: 12px;
                                    color: #595959;
                                    display: flex;
                                    align-items: center;
                                    flex-shrink: 0;
                                    margin-left: 10px;
                                    cursor: pointer;
                                    span{
                                        margin-right: 10px;
                                    }
                                }
                            }
                        }
            }
        }    }
}

/* 在线视频容器样式 */
.online-video-wrapper {
  width: 100%;
  margin: 16px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 8px;
}

/* 在线视频播放器样式 */
.online-video-container {
  max-width: 100%;
  max-height: 500px;
  width: 100%;
  height: auto;
  border-radius: 4px;
}
    .btn1 {
    //    width: 2.28rem;
    margin-top: .28rem;
        height: .53rem;
        border: 1px solid #191919;
        color: #656665;
        font-size: .28rem;
       color: #656665;
        line-height: .53rem;
        text-align: center;
        cursor:pointer;
        border-radius: .34rem;
    }
</style>
